import { RoomReward } from "../Model/RoomReward";
import { RoomRewards } from "../Model/RoomRewards";
export class RoomsService {
    constructor(httpService, roomsFactory, gamesFactory, playersFactory) {
        this.httpService = httpService;
        this.roomsFactory = roomsFactory;
        this.gamesFactory = gamesFactory;
        this.playersFactory = playersFactory;
    }
    async getRoomsStates() {
        const response = await this.httpService.get('rooms-states');
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener los estados de las salas.');
        }
        return response.json();
    }
    async getCurrentGameInRoom(roomId) {
        const response = await this.httpService.get(`room/${roomId}/game`);
        if (response.status === 404) {
            return null;
        }
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el juego actual de sala.');
        }
        return this.createGame(await response.json());
    }
    async getRoomStateReport(roomId) {
        const response = await this.httpService.get(`room/${roomId}/report`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el informe de estado de sala.');
        }
        const { room, game, players } = await response.json();
        return {
            room: this.createRoom(room),
            game: game ? this.createGame(game) : null,
            players: players.map(data => this.createPlayer(data))
        };
    }
    async getRooms() {
        const response = await this.httpService.get('rooms');
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener las salas.');
        }
        const content = await response.json();
        return content.map(data => this.createRoom(data));
    }
    async getRoom(roomId) {
        const response = await this.httpService.get(`room/${roomId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener la sala.');
        }
        return this.createRoom(await response.json());
    }
    async getRoomByGameCode(gameCode) {
        const response = await this.httpService.post(`room/code`, { gameCode });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener la sala.');
        }
        const data = await response.text();
        if (data) {
            return this.createRoom(JSON.parse(data));
        }
        else {
            return null;
        }
    }
    async getRanking(gameId) {
        const response = await this.httpService.get(`/game/${gameId}/ranking`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener la sala.');
        }
        return response.json();
    }
    createRoom(data) {
        const bingo = new RoomReward(data.roomRewards.bingo.text);
        const figure = new RoomReward(data.roomRewards.figure.text);
        const roomRewards = new RoomRewards(bingo, figure);
        return this.roomsFactory.createRoom(data.id, data.enabled, data.integratedDisplay, data.pictureId, data.name, data.state, data.gallery, data.offline, roomRewards);
    }
    createGame(data) {
        return this.gamesFactory.createGame(data.id, data.roomId, data.code, data.managerId, new Date(data.creationDate), data.type, data.state, data.waitTime, data.numbers, data.useCheckers);
    }
    createPlayer(dto) {
        return this.playersFactory.createPlayerFromDto(dto);
    }
}
